import { IRootState } from "../app/store";


export const selectedSpaceNumber = (state: IRootState) => state.design.selectedSpaceNumber;

